export function removeElement(el) {
  el.parentNode.removeChild(el)
}
